import acResource from './ac-resource.vue'

export default acResource
